import React, { Component } from 'react'
import { connect } from 'react-redux';
import { translate } from 'react-multi-lang'

class Employment extends Component {

    componentDidMount() {
        document.title = 'Screen Reader';
    }
    render() {
        const data = [{
            name: "Screen Access For All (SAFA)",
            link1: "http://safa-reader.software.informer.com/download/",
            type: "Free"

        },
        {
            name: "Non Visual Desktop Access (NVDA)",
            link1: "http://www.nvda-project.org/",
            type: "Free"

        },
        {
            name: "System Access To Go",
            link1: "http://www.satogo.com/",
            type: "Free"

        },
        {
            name: "Thunder",
            link1: "http://www.screenreader.net/index.php?pageid=2",
            type: "Commercial"

        }]
        return (
            <div className="tab-content">
                <div id="home" className=" tab-pane active">
                    <section className="login-form mt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12 p-0 mx-auto  tab-content border-0 cover-shadow   mb-3 mt-5  bg-white">
                                    <div className="panel-heading classredius">
                                        <h6 className="mb-0">Screen Reader</h6>
                                    </div>
                                    <div className="panel-body p-policy pt-0  p-3 ">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="table-responsive testable">

                                                    <div className="maintablebox">
                                                        <h2>Accessibility Statement</h2>
                                                        <p>
                                                            At <strong>Punjab Rozgar Department</strong>, we are committed to ensuring that all information on our platform is accessible to every user, regardless of the device, technology, or ability they use. Our platform is designed with the goal of providing maximum accessibility and usability to all visitors.
                                                        </p>
                                                        <p>
                                                            We strive to make sure that users with disabilities can access and navigate the platform effectively. For example, individuals with visual impairments can use assistive technologies such as screen readers and font magnifiers to interact with the site.
                                                        </p>
                                                        <p>
                                                            Our platform adheres to recognized accessibility standards and embraces the principles of usability and universal design to enhance the user experience for everyone.
                                                        </p>
                                                        <p>
                                                            Please note that some content on Punjab Rozgar Department may link to external websites. These external sites are managed by their respective agencies or departments, which are responsible for ensuring accessibility compliance.
                                                        </p>
                                                        <p>
                                                            If you encounter any issues or have suggestions related to the accessibility of this platform, kindly share your feedback by emailing us at
                                                            <strong> pgrkam.degt@gmail.com</strong>.
                                                        </p>

                                                        <h4>Screen Reader Access</h4>
                                                        <p>
                                                            Punjab Rozgar Department complies with the World Wide Web Consortium (W3C) Web Content Accessibility Guidelines (WCAG) 2.0 Level AA, as well as the Guidelines for Indian Government Websites. This compliance ensures that people with visual impairments can access the platform using assistive technologies like screen readers.
                                                        </p>
                                                        <p>
                                                            The platform's content is compatible with various popular screen readers, including JAWS, NVDA, SAFA, Supernova, Window-Eyes, and Thunder.
                                                        </p>

                                                        <h4>Commonly Used Screen Readers</h4>
                                                    </div>



                                                    {/* <h2>Screen Reader Access</h2>
                                                       <p>  This feature will enable people with visual impairments access the website using Assistive Technologies, such as screen readers. 
                                                           The information of this website is accessible with different screen readers, as mentioned below:
                                                        </p> */}
                                                    <table className="table table-striped tableclass">
                                                        <thead>
                                                            <tr>
                                                                <th width="5%">Sr.no</th>
                                                                <th width="30%">Screen Reader</th>
                                                                <th width="40%">Website</th>
                                                                <th width="25%">Free / Commercial</th>
                                                                {/* <th width="20%">If you want to register as a labourer, go to the link of your location/ District.</th>
                                                                <th width="20%">For getting help regarding registration as labourer/ employer, please contact the following Email of your location/ District</th>
                                                                <th width="20%">For getting help regarding registration as labourer/ employer, please contact the following Helpline No. of your location/ District</th> */}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {data && data.map((d, key) => {
                                                                return (<tr key={key}>
                                                                    <td>{key + 1} </td>
                                                                    <td>{d.name ? d.name : ''}</td>
                                                                    <td><a 
                                                                    aria-label='Visit Screen Reader link'
                                                                    rel="noopener noreferrer" target="_blank" href={d.link1}>{d.link1}</a></td>
                                                                    <td>{d.type}</td>
                                                                </tr>)
                                                            })}
                                                        </tbody>

                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        )
    }
}

const mapStateToProps = store => {
    return store;
};
export default connect(mapStateToProps)(translate(Employment));
